import {
    call,
    put,
    takeEvery,
    select,
} from 'redux-saga/effects';
import { uploadLeadProfilePhoto } from '../../requests/lead_profile_photos_request';
import { uploadLeadProfileRequestSuccess, uploadLeadProfileRequestFailure } from '../actions/lead_profile_photos.actions';
import { UPLOAD_LEAD_PROFILE_PHOTO_REQUEST } from '../constants/lead_profile_photos.constants';
import { message_error, message_success } from '../../../../../components/Message';

function* uploadLeadProfilePhotoSagaRequest({
    kind, picture, blemish_report_question,
}) {
    const leadId = yield select((state) => state.Leads.Lead_profile.Lead_general.root_id);
    try {
        const {
            result, msg, options, error,
        } = yield call(uploadLeadProfilePhoto, leadId, kind, picture, blemish_report_question);
        if (result) {
            yield put(uploadLeadProfileRequestSuccess(options));
            message_success(msg);
        } else if (error.errorNo === 1004 && error.errors['options.create.picture']) {
            yield put(uploadLeadProfileRequestFailure(error.errors['options.create.picture'].message));
            message_error(error.errors['options.create.picture'].message);
        } else {
            yield put(uploadLeadProfileRequestFailure(error.message));
            message_error(error.message);
        }
    } catch (e) {
        yield put(uploadLeadProfileRequestFailure(e.message));
        message_error(e.message);
    }
}

export default function* uploadLeadProfilePhotoSaga() {
    yield takeEvery(UPLOAD_LEAD_PROFILE_PHOTO_REQUEST, uploadLeadProfilePhotoSagaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/upload_lead_profile_photo.saga.js